import { DataBean } from "../DataBean";

export class FinancialMovementTaxState extends DataBean {



    public async getFinancialMovementTaxStateConstants(id: any,): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFinancialMovementTaxStateConstants_Number", [id]);
    }

}